import {useEffect, useState} from 'react';

export function useWaitForElement(selector: string): boolean {
	const [exists, setExists] = useState(() => {
		if (!selector) {
			return false;
		}

		return !!document.querySelector(selector);
	});

	useEffect(() => {
		if (!selector) {
			setExists(false);
			return undefined;
		}

		const syncElementPresence = () => {
			const nextExists = !!document.querySelector(selector);

			setExists(currentExists => (currentExists === nextExists ? currentExists : nextExists));
		};

		syncElementPresence();

		const observer = new MutationObserver(syncElementPresence);

		observer.observe(document.body, {childList: true, subtree: true});

		return () => observer.disconnect();
	}, [selector]);

	return exists;
}
